/* Below the Surface v5 behaviours (Oct 9 2026): reveal-on-scroll, parallax,
   bubble bursts, filter chips, tab/stage pickers, carousels and the quick-add
   that opens the theme's cart drawer. Everything is opt-in via data-ak5-* hooks. */
(function () {
  'use strict';
  var AK5 = window.AK5 = window.AK5 || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* ---------- reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ak5-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- parallax (mouse) ---------- */
  function initParallax() {
    if (!fine || reduce) return;
    document.querySelectorAll('[data-ak5-par]').forEach(function (zone) {
      var items = zone.querySelectorAll('.ak5-par');
      if (!items.length) return;
      var raf = null, px = 0, py = 0;
      zone.addEventListener('mousemove', function (e) {
        var r = zone.getBoundingClientRect();
        px = ((e.clientX - r.left) / r.width - 0.5) * 2;
        py = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          items.forEach(function (it) { it.style.setProperty('--px', px.toFixed(3)); it.style.setProperty('--py', py.toFixed(3)); });
        });
      });
      zone.addEventListener('mouseleave', function () {
        items.forEach(function (it) { it.style.setProperty('--px', 0); it.style.setProperty('--py', 0); });
      });
    });
  }

  /* ---------- bubble bursts on click ---------- */
  function burst(layer, x, y) {
    if (reduce) return;
    for (var i = 0; i < 7; i++) {
      var s = document.createElement('span');
      var size = 6 + Math.random() * 16;
      s.className = 'ak5-burst';
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.width = size + 'px'; s.style.height = size + 'px';
      s.style.setProperty('--dx', (Math.random() * 120 - 60).toFixed(0) + 'px');
      s.style.animationDelay = (Math.random() * 0.25).toFixed(2) + 's';
      layer.appendChild(s);
      setTimeout(function (el) { el.remove(); }.bind(null, s), 2800);
    }
  }
  function initBursts() {
    document.querySelectorAll('[data-ak5-burst]').forEach(function (layer) {
      var zone = layer.parentElement;
      zone.addEventListener('click', function (e) {
        if (e.target.closest('a,button,input,select,textarea,label')) return;
        var r = layer.getBoundingClientRect();
        burst(layer, e.clientX - r.left, e.clientY - r.top);
      });
    });
  }
  AK5.burst = burst;

  /* ---------- filter chips ---------- */
  function initFilters() {
    document.querySelectorAll('[data-ak5-filter]').forEach(function (bar) {
      var target = document.querySelector(bar.getAttribute('data-ak5-filter'));
      if (!target) return;
      var chips = bar.querySelectorAll('[data-tag]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var tag = c.getAttribute('data-tag');
          chips.forEach(function (o) { o.classList.toggle('is-on', o === c); o.setAttribute('aria-pressed', o === c); });
          target.querySelectorAll('[data-ak5-tags]').forEach(function (card) {
            var tags = (card.getAttribute('data-ak5-tags') || '').split(/\s+/);
            var show = tag === 'all' || tags.indexOf(tag) > -1;
            card.classList.toggle('is-hidden', !show);
          });
          if (window.AK5 && AK5.burst && bar.getAttribute('data-ak5-burst-layer')) {
            var layer = document.querySelector(bar.getAttribute('data-ak5-burst-layer'));
            if (layer) { var r = c.getBoundingClientRect(), lr = layer.getBoundingClientRect(); burst(layer, r.left - lr.left + r.width / 2, r.top - lr.top + r.height / 2); }
          }
        });
      });
    });
  }

  /* ---------- tab / stage pickers ---------- */
  function initTabs() {
    document.querySelectorAll('[data-ak5-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-ak5-tab]');
      var panels = group.querySelectorAll('[data-ak5-panel]');
      var tide = group.querySelector('[data-ak5-tide]');
      var num = group.querySelector('[data-ak5-stage-num]');
      function pick(key, el) {
        tabs.forEach(function (t) { var on = t.getAttribute('data-ak5-tab') === key; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); if (t.hasAttribute('aria-pressed')) t.setAttribute('aria-pressed', on); });
        panels.forEach(function (p) { var on = p.getAttribute('data-ak5-panel') === key; p.hidden = !on; if (on) { p.classList.remove('ak5-pop'); void p.offsetWidth; p.classList.add('ak5-pop'); } });
        if (tide && el && el.getAttribute('data-pct')) tide.style.width = el.getAttribute('data-pct');
        if (num && el && el.getAttribute('data-num')) num.textContent = el.getAttribute('data-num');
      }
      tabs.forEach(function (t) {
        var ev = group.getAttribute('data-ak5-tabs') === 'hover' && fine ? 'mouseenter' : 'click';
        t.addEventListener(ev, function () { pick(t.getAttribute('data-ak5-tab'), t); });
        if (ev === 'mouseenter') t.addEventListener('click', function () { pick(t.getAttribute('data-ak5-tab'), t); });
      });
      var first = group.querySelector('[data-ak5-tab].is-on') || tabs[0];
      if (first) pick(first.getAttribute('data-ak5-tab'), first);
      group._ak5pick = pick;
    });
  }

  /* ---------- carousels (scroll-snap tracks) ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-ak5-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-ak5-track]');
      if (!track) return;
      function step() { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 20 : 320; }
      wrap.querySelectorAll('[data-ak5-prev]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      wrap.querySelectorAll('[data-ak5-next]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    });
  }

  /* ---------- video cards ---------- */
  function initVideos() {
    document.querySelectorAll('[data-ak5-video]').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        if (v.paused) {
          document.querySelectorAll('[data-ak5-video] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-ak5-video]').classList.remove('is-playing'); } });
          v.muted = false; v.play(); card.classList.add('is-playing');
        } else { v.pause(); card.classList.remove('is-playing'); }
      });
      v.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  /* ---------- cart ---------- */
  function drawerSectionId() {
    var ds = document.querySelector('.shopify-section[id*="cart-drawer"]');
    return ds ? ds.id.replace('shopify-section-', '') : 'cart-drawer';
  }
  function applyDrawer(html) {
    if (!html) return false;
    var live = document.getElementById('CartDrawer');
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
    if (!live || !fresh) return false;
    live.innerHTML = fresh.innerHTML;
    return true;
  }
  function openCart() {
    if (typeof window.__nsw2OpenCart === 'function') { window.__nsw2OpenCart(); return; }
    var btn = document.querySelector('.cart-drawer-button');
    if (btn) { btn.click(); return; }
    var d = document.getElementById('CartDrawer'), o = document.getElementById('CartOverlay');
    if (d) d.classList.add('active');
    if (o) o.classList.add('active');
  }
  function updateCount() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('cart-count, .cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; el.setAttribute('aria-label', c.item_count + ' items'); });
      document.documentElement.classList.toggle('cart-has-items', c.item_count > 0);
    }).catch(function () {});
  }
  function refreshDrawer() {
    var id = drawerSectionId();
    return fetch(window.location.pathname + '?sections=' + id, { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (d) { applyDrawer(d && (d[id] || d['cart-drawer'])); });
  }
  /* items: [{id, quantity, selling_plan?}] */
  function addToCart(items, opts) {
    opts = opts || {};
    var id = drawerSectionId();
    var body = { items: items.map(function (it) { var o = { id: Number(it.id), quantity: it.quantity || 1 }; if (it.selling_plan) o.selling_plan = Number(it.selling_plan); if (it.properties) o.properties = it.properties; return o; }), sections: id };
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to cart'); }); return r.json(); })
      .then(function (data) {
        var html = data && data.sections && (data.sections[id] || data.sections['cart-drawer']);
        var p = applyDrawer(html) ? Promise.resolve() : refreshDrawer();
        return p.then(function () { updateCount(); if (opts.open !== false) openCart(); document.dispatchEvent(new CustomEvent('ak5:added', { detail: data })); return data; });
      });
  }
  AK5.addToCart = addToCart;
  AK5.openCart = openCart;

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ak5-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var qty = Number(b.getAttribute('data-qty') || 1);
      var plan = b.getAttribute('data-plan') || null;
      var label = b.innerHTML;
      b.disabled = true; b.classList.add('is-busy');
      if (b.classList.contains('ak5-btn')) b.innerHTML = 'Adding…';
      addToCart([{ id: b.getAttribute('data-ak5-add'), quantity: qty, selling_plan: plan }])
        .then(function () { if (b.classList.contains('ak5-btn')) b.innerHTML = 'Added ✓'; setTimeout(function () { b.innerHTML = label; }, 1800); })
        .catch(function (err) { if (b.classList.contains('ak5-btn')) b.innerHTML = label; alert(err.message); })
        .then(function () { b.disabled = false; b.classList.remove('is-busy'); });
    });
  }

  /* ---------- header shadow on scroll ---------- */
  function initHeader() {
    var last = -1;
    function tick() { var y = window.scrollY || 0; var on = y > 12; if (on !== last) { document.documentElement.classList.toggle('ak5-scrolled', on); last = on; } }
    window.addEventListener('scroll', tick, { passive: true }); tick();
  }

  /* ---------- accordions: one open at a time per group ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-ak5-acc]').forEach(function (g) {
      g.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) g.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; }); });
      });
    });
  }

  function init() {
    initReveal(); initParallax(); initBursts(); initFilters(); initTabs(); initCarousels(); initVideos(); initQuickAdd(); initHeader(); initAccordions();
    document.dispatchEvent(new CustomEvent('ak5:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initTabs(); initCarousels(); initFilters(); });
})();

/* ---------- depth meter + photo stacks (Oct 9 feedback round 2) ---------- */
(function () {
  'use strict';
  function initDepth() {
    if (!document.querySelector('.ak5-hero, .ak5-pdp, .ak5-coll')) return;
    var root = document.createElement('div');
    root.className = 'ak5-depth'; root.setAttribute('aria-hidden', 'true');
    root.innerHTML = '<span class="ak5-depth__lab">Depth</span><span class="ak5-depth__track"><span class="ak5-depth__fill"></span></span><span class="ak5-depth__num">0 m</span>';
    document.body.appendChild(root);
    var num = root.querySelector('.ak5-depth__num'), fill = root.querySelector('.ak5-depth__fill');
    var se = document.scrollingElement || document.documentElement, raf = null;
    function tick() {
      raf = null;
      var max = se.scrollHeight - window.innerHeight;
      if (max < 400) { document.documentElement.classList.remove('ak5-scrollable'); return; }
      document.documentElement.classList.add('ak5-scrollable');
      var p = Math.max(0, Math.min(1, se.scrollTop / max));
      num.textContent = Math.round(p * 200) + ' m';
      fill.style.setProperty('--dp', (p * 100).toFixed(1) + '%');
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    window.addEventListener('resize', tick); tick();
  }
  /* stack items follow the tab groups: [data-ak5-stackitem="key"] inside a [data-ak5-tabs] group */
  function initStacks() {
    document.querySelectorAll('[data-ak5-tabs]').forEach(function (group) {
      var items = group.querySelectorAll('[data-ak5-stackitem]');
      if (!items.length) return;
      group.querySelectorAll('[data-ak5-tab]').forEach(function (t) {
        t.addEventListener('click', function () { var k = t.getAttribute('data-ak5-tab'); items.forEach(function (it) { it.classList.toggle('is-on', it.getAttribute('data-ak5-stackitem') === k); }); });
      });
      var first = group.querySelector('[data-ak5-tab].is-on') || group.querySelector('[data-ak5-tab]');
      if (first) { var k0 = first.getAttribute('data-ak5-tab'); items.forEach(function (it) { it.classList.toggle('is-on', it.getAttribute('data-ak5-stackitem') === k0); }); }
    });
  }
  function init() { initDepth(); initStacks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
